function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm5.037 7.886c-.36-.36-.945-.36-1.305 0l-5.405 5.403-2.12-1.767-.094-.069c-.386-.248-.905-.175-1.207.187-.326.391-.273.974.118 1.3l2.77 2.308.095.07c.36.229.839.183 1.148-.127l6-6 .077-.087c.282-.362.256-.885-.077-1.218z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/success.ab924114.svg";
export { SvgComponent as ReactComponent };